import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import ar from "../../locale";
import { title, toolbarOptions } from "../../constants";
import firebase from "../../lib/firebase";
import Loading from "../../lib/Loading";

export default class Social extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      social: {},
      loading: false,
    };
    this.socialRef = firebase.database().ref("/social");
  }

  componentDidMount() {
    super.componentDidMount();
    document.title = title;
    this.quill = new window.Quill("#quill-editor", {
      modules: {
        toolbar: toolbarOptions,
      },
      theme: "snow",
    });
    this.socialRef.on("value", (response) => {
      this.state.social = response.val();
      this.quill.root.innerHTML = this.state.social.terms;
      this.updateState();
    });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.socialRef.off("value");
  }

  showLoading = (show) => {
    this.state.loading = show;
    this.updateState();
  };

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  updateSocialDetails = () => {
    let facebook = this.facebook.value;
    let twitter = this.twitter.value;
    let instagram = this.instagram.value;
    let website = this.website.value;
    let content = this.quill.root.innerHTML;
    let contentText = null;
    if (content) {
      contentText = this.$(content).text(); //this is just for validation
    }
    if (facebook && twitter && instagram && website && contentText) {
      this.showLoading(true);
      this.socialRef
        .update({
          facebook: facebook,
          twitter: twitter,
          instagram: instagram,
          website: website,
          terms: content,
        })
        .then((res) => {
          this.showSuccess(ar.operation_successful);
          this.showLoading(false);
        })
        .catch((error) => {
          this.showError(error.message);
          this.showLoading(false);
        });
    } else {
      this.showError(ar.please_fill_all_options);
    }
  };

  render() {
    let { facebook, twitter, instagram, website } = this.state.social;
    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card no-toolbar border-0">
                <div className="card-body">
                  <h2 className="card-title">{ar.settings}</h2>
                  <h5 className="card-subtitle mb-0">
                    {ar.enter_valid_details}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="form-group">
                    <label
                      htmlFor="facebook"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.facebook}
                    </label>
                    <input
                      type="text"
                      ref={(e) => (this.facebook = e)}
                      defaultValue={facebook}
                      className="form-control"
                      id="facebook"
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="twitter"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.twitter}
                    </label>
                    <input
                      type="text"
                      ref={(e) => (this.twitter = e)}
                      defaultValue={twitter}
                      className="form-control"
                      id="twitter"
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="instagram"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.instagram}
                    </label>
                    <input
                      type="text"
                      ref={(e) => (this.instagram = e)}
                      defaultValue={instagram}
                      className="form-control"
                      id="instagram"
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="website"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.website}
                    </label>
                    <input
                      type="text"
                      ref={(e) => (this.website = e)}
                      defaultValue={website}
                      className="form-control"
                      id="website"
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="terms"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.terms_and_conditions}
                    </label>
                    <div id="quill-editor" className="min-h200"></div>
                  </div>
                  <div className="button-group mt-3">
                    <button
                      type="button"
                      className="btn waves-effect waves-light btn-rounded btn-info min-w100"
                      onClick={this.updateSocialDetails}
                    >
                      {ar.save}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Loading show={this.state.loading} />
      </div>
    );
  }
}
